import {normalizeSize} from '@/constants/sizing';
import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const PLAYER_BAR_HEIGHT = normalizeSize(75);

export const styles = createThemedStyles(theme => ({
  header: {
    alignItems: 'center',
  },
  gridHeader: {
    alignItems: 'flex-start',
  },
  contentContainerStyle: {
    flexGrow: 1,
    padding: spacing.s,
  },
  minimalPlayerBox: {
    height: PLAYER_BAR_HEIGHT,
    backgroundColor: theme.colors.backgroundDark,
  },
}));
